import axios from 'axios';
import { LoadingStates } from 'shared/constants/loadingStates';
import _ from 'lodash';
import { clearForm } from './formSlice';
import { PLANT_API_BASE_URL } from 'shared/constants/constants';

const { createSlice, createAsyncThunk } = require('@reduxjs/toolkit');

const initialState = {
  data: null,
  status: 'idle',
  error: null,
};

const plantItemLicenceTypesSlice = createSlice({
  name: 'plantItemLicence',
  initialState,
  reducers: {
    clearPlantItemLicenceTypes() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPlantItemLicenceTypes.pending, (state, action) => {
        state.status = LoadingStates.Loading;
      })
      .addCase(getPlantItemLicenceTypes.fulfilled, (state, action) => {
        state.data = action.payload;
        state.status = LoadingStates.Succeeded;
      })
      .addCase(getPlantItemLicenceTypes.rejected, (state, action) => {
        state.status = LoadingStates.Rejected;
        state.status = action.error.message;
      })
      .addCase(clearForm, () => {
        return initialState;
      });
  },
});

const apiUrl = `${PLANT_API_BASE_URL}/item/licences`;

export const getPlantItemLicenceTypes = createAsyncThunk(
  'plantItemLicence/getLicenceTypes',
  async () => {
    const res = await axios.get(apiUrl, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return res.data.response;
  },
  {
    condition: (arg, { getState }) => {
      const { plantItemLicenceTypes } = getState();
      return _.isEmpty(plantItemLicenceTypes.data) && plantItemLicenceTypes.status !== LoadingStates.Loading;
    },
  },
);

export const { clearPlantItemLicenceTypes } = plantItemLicenceTypesSlice.actions;
export const plantItemLicenceTypesReducer = plantItemLicenceTypesSlice.reducer;
